import { useNavigate, Link } from "react-router-dom";
import useMemLogout from "../../../hooks/useMemLogout";

export const MemberSidebarData = [
    {
        title: 'Dashboard',
        path: '/member/dashboard',
    },
    {
        title: 'Curriculum Vitae',
        subNav: [
            {
                title: 'Upload CV',
                path: '/curriculum_vitae',
            },
            {
                title: 'View CV',
                path: '/view_curriculum_vitae',
            },
            {
                title: 'Replace CV',
                path: '/replace_curriculum_vitae',
            },
        ]
    },
    {
        title: 'Member Profile',
        subNav: [
            {
                title: 'View Profile',
                path: '/view_profile',
            },
            {
                title: 'Update Profile',
                path: '/update_profile',
            },
        ]
    },
    {
        title: 'Member Account',
        subNav: [
            {
                title: 'Payment Transactions',
                path: '/member_payment_transactions',
            },
            {
                title: 'Ledger Account',
                path: '/member_ledger_account',
            },
            {
                title: 'Member Statement',
                path: '/member_statement',
            },
            // {
            //     title: 'New Statement',
            //     path: '/pdf_service',
            // },
        ]
    },
    {
        title: 'Make Payment',
        subNav: [
            {
                title: '2M2 Payment',
                path: '/member_2m2_payments',
            },
            {
                title: 'Regular Payment',
                path: '/member_regular_payments',
            },
        ]
    },
    {
        title: 'Contact PROFORUM',
        path: '/contact_proforum',
    },
    {
        title: 'Change Password',
        path: '/change_member_password',
    },
    {
        title: 'Log Out',
        path: '/member_logout',
    },
 
];

